export const palette = {
  mode: 'light' as const,
  common: {
    white: '#FFFFFF',
    black: '#000000',
  },
  primary: {
    main: '#212121',
    light: '#424242',
    dark: '#000000',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#616161',
    light: '#9e9e9e',
    dark: '#424242',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#424242',
    light: '#757575',
    dark: '#212121',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#ffcc80',
    light: '#ffe0b2',
    dark: '#e65100',
    contrastText: '#bf360c',
  },
  success: {
    main: '#a5d6a7',
    light: '#c8e6c9',
    dark: '#2e7d32',
    contrastText: '#1b5e20',
  },
  info: {
    main: '#616161',
    light: '#9e9e9e',
    dark: '#424242',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#00070F',
    secondary: '#4F515A',
  },
  amount: {
    main: '#003669',
    dark: '#003366',
  },
  teal: {
    main: '#72F5F5',
    dark: '#5EE5E5',
  },
  red: {
    main: '#C62828',
    dark: '#B71C1C',
  },
  placeholder: '#9e9e9e',
  background: {
    default: '#F2EBDD',
    container: '#FAF7F1',
    paper: '#FFFFFF',
  },
  buttonDecline: '#5C4A42',
  buttonCreateMatter: '#0FF8F6',
  darkNavy: '#002349',
  statusInactive: '#90A4AE',
  matterStatus: {
    active: {
      bg: '#c8e6c9',
      text: '#2e7d32',
    },
    inactive: {
      bg: '#e8ebe8',
      text: '#5c6b5c',
    },
    closed: {
      bg: '#eeeeee',
      text: '#616161',
    },
  },
  mattersDropdown: {
    trigger: 'rgba(0, 0, 0, 0.04)',
    triggerHover: 'rgba(0, 0, 0, 0.08)',
  },
  action: {
    active: 'rgba(0, 0, 0, 0.54)',
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(0, 0, 0, 0.08)',
    disabled: 'rgba(0, 0, 0, 0.26)',
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },
};
